import { RadarChartOutlined } from "@ant-design/icons";
import { radarCore } from "./core/radar";
import { defineWidget } from "../widgetDefinition";
import { radarSlots } from "../Slots";
import { radarDuplicate } from "../Duplication/radar";
import { radarControlPanel } from "../ControlPanel/radar";
import type { RadarComponentSpec } from "../Processing/types";
import { RadarWidget } from "../WidgetComponents/RadarWidget";
import { RadarInfo } from "../Info/radar";
import { RadarConfigurator } from "../AddWidgetModal/RadarConfigurator";
import { BINDABLE_SECTIONS } from "../Processing/controllerBindings";

export const radarDefinition = defineWidget<RadarComponentSpec>({
  ...radarCore,
  type: "radar",
  dynamic: { bindableSections: BINDABLE_SECTIONS.radar },
  slots: radarSlots,
  duplicate: radarDuplicate,
  controlPanel: radarControlPanel,
  info: { Content: RadarInfo },
  schema: ["display", "normalization", "customMin", "customMax", "metric_names", "series", "radar_builder_misc", "vertexDimension"],
  contractHash: "024c4v32dr3",
  needsData: true,

  template: {
    label: "Radar Chart",
    description: "Compare multiple metrics across players or groups",
    icon: <RadarChartOutlined />,
  },

  defaultLayout: { w: 5, h: 12, minW: 3, minH: 4 },

  gridComponent: ({ id }) => <RadarWidget id={id} />,

  configurator: {
    modalTitle: "Radar Chart",
    wide: true,
    Component: RadarConfigurator,
  },
});
